<template>
  <div
    class="progress-bar"
    data-ui="progress-bar"
    :style="cssVars"
  >
    <div
      class="progress-bar__progress"
      data-ui="progress-bar-progress"
    />
  </div>
</template>

<script>
/**
 * The progress bar for the Day Checkout Wizard
 * @displayName Progress Bar
 * @example
 * <progress-bar
 *  :height="height"
 *  :currentStep="currentStep"
 *  :amountOfSteps="amountOfSteps"
 * />
 */
export default {
  name: 'ProgressBar',
  props: {
    /**
     * The height of the progress bar
     */
    height: {
      type: Number,
      required: true,
    },
    /**
     * The current step of the wizard
     */
    currentStep: {
      type: Number,
      required: true,
    },
    /**
     * The amount of steps in the wizard
     */
    amountOfSteps: {
      type: Number,
      required: true,
    },
  },
  computed: {
    /**
     * Calculates the percentage completion of the wizard
     * @returns the percentage completion
     */
    progress() {
      const { currentStep, amountOfSteps } = this;
      return Math.ceil((currentStep / amountOfSteps) * 100);
    },
    /**
     * Creates height and width css vars
     * @returns the css var object
     */
    cssVars() {
      return {
        '--height': `${this.height}px`,
        '--progressWidth': `${this.progress}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.progress-bar {
  width: 100%;
  height: var(--height);
  background-color: $cdr-color-background-message-default-02;

  &__progress {
    width: var(--progressWidth);
    height: 100%;
    background-color: #acb4a2;
  }
}
</style>
